export default __webpack_public_path__ + "static/media/DoubleDay_750x600.480e31d5.jpg";